import { useEffect, useState } from "react";
import { db } from "../firebase";
import {
  collection,
  getDocs,
  collectionGroup,
} from "firebase/firestore";
import { useNavigate } from "react-router-dom";

function Dashboard() {
  const navigate = useNavigate(); // ✅ correct place

  const [stats, setStats] = useState({
    users: 0,
    tournaments: 0,
    completed: 0,
    winners: 0,
    profit: 0,
    totalDeposit: 0,
    totalWithdraw: 0,
    pendingDeposit: 0,
    pendingWithdraw: 0,
    totalWager: 0,
    totalWallet: 0,
    totalBalance: 0,
  });

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      // USERS
      const usersSnap = await getDocs(collection(db, "users"));

      let totalWager = 0;
      let totalWallet = 0;

      usersSnap.forEach((doc) => {
        const u = doc.data();
        totalWager += u.wager || 0;
        totalWallet += u.withdrawable || 0;
      });

      // TOURNAMENTS
      const collectionsList = [
        "cs_tournaments",
        "lw_tournaments",
        "br_tournaments",
        "br_s_tournaments",
        "onetap_tournaments",
      ];

      let totalTournaments = 0;
      let completedMatches = 0;
      let totalProfit = 0;

      for (let col of collectionsList) {
        const snap = await getDocs(collection(db, col));

        totalTournaments += snap.size;

        snap.forEach((doc) => {
          const data = doc.data();

          if (data.status === "completed") {
            completedMatches++;
          

          const entry = data.entryFee || 0;
          const spots = data.totalSpots || 0;
          const prize = data.prizePool || 0;

          totalProfit += entry * spots - prize;}
        });
      }

      // WINNERS
      const winnersSnap = await getDocs(collectionGroup(db, "winners"));

      // DEPOSIT
      const depositSnap = await getDocs(collection(db, "deposit_requests"));

      let totalDeposit = 0;
      let pendingDeposit = 0;

      depositSnap.forEach((doc) => {
        const d = doc.data();
        if (d.status === "approved") totalDeposit += d.amount || 0;
        if (d.status === "pending") pendingDeposit += d.amount || 0;
      });

      // WITHDRAW
      const withdrawSnap = await getDocs(collection(db, "withdraw_requests"));

      let totalWithdraw = 0;
      let pendingWithdraw = 0;

      withdrawSnap.forEach((doc) => {
        const d = doc.data();
        if (d.status === "approved") totalWithdraw += d.amount || 0;
        if (d.status === "pending") pendingWithdraw += d.amount || 0;
      });

      setStats({
        users: usersSnap.size,
        tournaments: totalTournaments,
        completed: completedMatches,
        winners: winnersSnap.size,
        profit: totalProfit,
        totalDeposit,
        totalWithdraw,
        pendingDeposit,
        pendingWithdraw,
        totalWager,
        totalWallet,
        totalBalance: totalWager + totalWallet,
      });

    } catch (e) {
      console.error("Dashboard Error:", e);
    }
  };

  return (
    <div style={container}>
      <h1 style={title}>🔥 Admin Dashboard</h1>

      <div style={grid}>
        <Card title="👥 Total Users" value={stats.users} onClick={() => navigate("/users")} />
        <Card title="🎮 Tournaments" value={stats.tournaments} onClick={() => navigate("/tournaments")} />
        <Card title="✅ Completed" value={stats.completed} onClick={() => navigate("/tournaments")} />
        <Card title="🏆 Winners" value={stats.winners} />

        <Card title="💰 Profit" value={`₹${stats.profit}`} />

        <Card title="💳 Total Deposit" value={`₹${stats.totalDeposit}`} onClick={() => navigate("/top-deposit")} />
        <Card title="💸 Total Withdraw" value={`₹${stats.totalWithdraw}`} onClick={() => navigate("/top-withdraw")} />

        <Card title="🕐 Pending Deposit" value={`₹${stats.pendingDeposit}`} onClick={() => navigate("/deposit")} />
        <Card title="🕐 Pending Withdraw" value={`₹${stats.pendingWithdraw}`} onClick={() => navigate("/withdraw")} />

        <Card title="🎯 Total Wager" value={`₹${stats.totalWager}`} onClick={() => navigate("/top-wager")} />
        <Card title="💼 Withdrawable" value={`₹${stats.totalWallet}`} onClick={() => navigate("/users")} />
        <Card title="🧮 Total Balance" value={`₹${stats.totalBalance}`} onClick={() => navigate("/top-balance")} />
      </div>
    </div>
  );
}

// 🔥 CARD
function Card({ title, value, onClick }) {
  const [hover, setHover] = useState(false);

  return (
    <div
      onClick={onClick}
      style={{
        ...card,
        transform: hover ? "translateY(-5px)" : "none",
        background: hover ? "#222842" : "#1A1F2E",
        cursor: onClick ? "pointer" : "default",
        boxShadow: hover ? "0 0 20px rgba(37,99,235,0.3)" : "none",
      }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <h3 style={cardTitle}>{title}</h3>
      <h2 style={cardValue}>{value}</h2>
    </div>
  );
}

// STYLES
const container = {
  color: "white",
  padding: 20,
  background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
  minHeight: "100vh",
};

const title = {
  textAlign: "center",
  fontSize: 28,
  fontWeight: "bold",
};

const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))",
  gap: 24,
  marginTop: 30,
};

const card = {
  background: "#1A1F2E",
  padding: 20,
  borderRadius: 14,
  textAlign: "center",
  border: "1px solid rgba(255,255,255,0.05)",
  transition: "all 0.25s ease",
};

const cardTitle = {
  marginBottom: 10,
  fontSize: 14,
  opacity: 0.7,
};

const cardValue = {
  fontSize: 24,
  fontWeight: "bold",
};

export default Dashboard;